import { render, staticRenderFns } from "./TargetingAdblock.vue?vue&type=template&id=2927c2f2&"
import script from "./TargetingAdblock.vue?vue&type=script&lang=js&"
export * from "./TargetingAdblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports